import { getQuarter, getYear, isBefore, isValid, startOfDay } from 'date-fns';
import { Account } from '../../../../types';
import { AdvisoryOpportunity } from '../../../../types/advise';
import { getDate } from '../../../../utils/helpers';

export const OPPORTUNITY_NAME_MAX_LENGTH = 120;

export const defaultEngagementName = (account: Account, productName: string): string =>
  `${account.name} ${productName} Evaluation`;

export const defaultOpportunityName = (account: Account, productName: string): string =>
  [account.name, productName, account.billingCity?.trim(), 'Supplier Comparison'].filter(Boolean).join(' | ');

export const opportunityOptionLabel = (opportunity: AdvisoryOpportunity): string => {
  const closeDate = opportunity.close_date ? getDate(opportunity.close_date) : null;
  if (!closeDate || !isValid(closeDate)) return opportunity.name;
  return `${opportunity.name} — Q${getQuarter(closeDate)} ${getYear(closeDate)}`;
};

export const opportunityNameError = (name: string): string | null => {
  if (!name.trim()) return 'Opportunity Name is required';
  if (name.length > OPPORTUNITY_NAME_MAX_LENGTH) {
    return `Opportunity Name must be ${OPPORTUNITY_NAME_MAX_LENGTH} characters or fewer`;
  }
  return null;
};

export const closeDateError = (closeDate: Date | null, now: Date = new Date()): string | null => {
  if (!closeDate) return 'Close Date is required';
  if (!isValid(closeDate)) return 'Close Date must be a valid date';
  if (isBefore(startOfDay(closeDate), startOfDay(now))) return 'Close Date must be today or later';
  return null;
};

export const newOpportunityError = (name: string, closeDate: Date | null, now: Date = new Date()): string | null =>
  opportunityNameError(name) ?? closeDateError(closeDate, now);
